export default __webpack_public_path__ + "static/media/blueLady.88fd41a1.webp";